import ResourcesModule from '../../resources/resources';

export class UserGroupsModalController {
  /* @ngInject */
  constructor(userGroup,close,$stateParams,Resource,UserExplorerUserGroupsResource) {
    this.close = close;
    this.$stateParams = $stateParams;
    this.Resource = Resource;
    this.UserExplorerUserGroupsResource = UserExplorerUserGroupsResource;

    this.getUserGroups();
  }

  getUserGroups() {
    this.UserExplorerUserGroupsResource.one('by-game').one(this.$stateParams.gameId).get()
      .then((userGroups) => {
        this.userGroups = userGroups.plain();
      });
  }

  selectUserGroup(userGroup) {
    this.selectedUserGroup = userGroup;
  }
}

export default angular.module('app.components.explore.userGroupsModal', [])
  .controller('UserGroupsModalController', UserGroupsModalController);



/** WEBPACK FOOTER **
 ** ./src/components/explore/userGroupsModal.js
 **/